import mp3_1 from './sounds/1.mp3';
import mp3_2 from './sounds/2.mp3';
import mp3_3 from './sounds/3.mp3';
import mp3_4 from './sounds/4.mp3';
import mp3_5 from './sounds/5.mp3';
import mp3_6 from './sounds/6.mp3';
import mp3_7 from './sounds/7.mp3';
import mp3_8 from './sounds/8.mp3';
import mp3_9 from './sounds/9.mp3';
import mp3_10 from './sounds/10.mp3';
import mp3_a from './sounds/a.mp3';
import mp3_b from './sounds/b.mp3';
import mp3_c from './sounds/c.mp3';
import mp3_d from './sounds/d.mp3';
import mp3_e from './sounds/e.mp3';
import mp3_f from './sounds/f.mp3';
import mp3_g from './sounds/g.mp3';
import mp3_h from './sounds/h.mp3';
import mp3_i from './sounds/i.mp3';
import mp3_j from './sounds/j.mp3';
import mp3_k from './sounds/k.mp3';
import mp3_l from './sounds/l.mp3';
import mp3_m from './sounds/m.mp3';
import mp3_n from './sounds/n.mp3';
import mp3_o from './sounds/o.mp3';
import mp3_p from './sounds/p.mp3';
import mp3_q from './sounds/q.mp3';
import mp3_r from './sounds/r.mp3';
import mp3_s from './sounds/s.mp3';
import mp3_t from './sounds/t.mp3';
import mp3_u from './sounds/u.mp3';
import mp3_v from './sounds/v.mp3';
import mp3_w from './sounds/w.mp3';
import mp3_x from './sounds/x.mp3';
import mp3_y from './sounds/y.mp3';
import mp3_z from './sounds/z.mp3';



export const shapes = [
    {
        value: 'square',
        img: 'http://www.kidprintables.com/flashcards/square.gif',
        sound: ''
    },
    {
        value: 'circle',
        img: 'http://www.kidprintables.com/flashcards/circle.gif',
        sound: ''
    },
    {
        value: 'triangle',
        img: 'http://www.kidprintables.com/flashcards/triangle.gif',
        sound: ''
    },
    {
        value: 'rectangle',
        img: 'http://www.kidprintables.com/flashcards/rectangle.gif',
        sound: ''
    },
    {
        value: 'diamond',
        img: 'http://www.kidprintables.com/flashcards/diamond.gif',
        sound: ''
    },
    {
        value: 'heart',
        img: 'http://www.kidprintables.com/flashcards/heart.gif',
        sound: ''
    },
    {
        value: 'oval',
        img: 'http://www.kidprintables.com/flashcards/oval.gif',
        sound: ''
    },
    {
        value: 'star',
        img: 'http://www.kidprintables.com/flashcards/star.gif',
        sound: ''
    }
]


export const numbers = [
    {
        id: 1,
        value: '1',
        img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/flashcards/flashcard1.gif',
        sound: mp3_1
    },
    {
        id: 2,        
        value: '2',
        img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/flashcards/flashcard2.gif',
        sound: mp3_2
    },
    {        
        id: 3,        
        value: '3',
        img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/flashcards/flashcard3.gif',
        sound: mp3_3
    },
    {
        id: 4,        
        value: '4',
        img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/flashcards/flashcard4.gif',
        sound: mp3_4
    },
    {
        id: 5,        
        value: '5',
        img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/flashcards/flashcard5.gif',
        sound: mp3_5 
    },
    {
        id: 6,        
        value: '6',
        img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/flashcards/flashcard6.gif',
        sound: mp3_6 
    },
    {
        id: 7,        
        value: '7',
        img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/flashcards/flashcard7.gif',
        sound: mp3_7
    },
    {
        id: 8,        
        value: '8',
        img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/flashcards/flashcard8.gif',
        sound: mp3_8
    },
    {
        id: 9,        
        value: '9',
        img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/flashcards/flashcard9.gif',
        sound: mp3_9  
    },
    {
        id: 10,        
        value: '10',
        img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/flashcards/flashcard10.gif',
        sound: mp3_10 
    }
]

export const letters = [
    {
        id: 1,
        value: 'a',
        img: 'http://2.bp.blogspot.com/-tJ9jvSlqYAI/Tkq9QbuDhVI/AAAAAAAAIVY/8TMpzC8fVNU/s200/letter-a.jpg',
        sound: mp3_a       
    },
    {
        id: 2,
        value: 'b',
        img: 'http://2.bp.blogspot.com/-bWcZAMS_Oy8/Tkq9TKOU-lI/AAAAAAAAIVc/Aqu_iMVOsr0/s200/letter-b.jpg',
        sound: mp3_b        
    },
    {
        id: 3,
        value: 'c',
        img: 'http://3.bp.blogspot.com/-xF0i9ovfwbY/Tkq9UcaKweI/AAAAAAAAIVg/p7KHcXXoS2c/s200/letter-c.jpg',
        sound: mp3_c       
    },
    {
        id: 4,        
        value: 'd',
        img: 'http://4.bp.blogspot.com/-qEBx8QjNFsU/Tkq-jJSuohI/AAAAAAAAIVk/uOcOaK_raio/s200/letter-d.jpg',
        sound: mp3_d       
    },
    {
        id: 5,
        value: 'e',
        img: 'http://4.bp.blogspot.com/-AQYOyRAb4og/Tkq-kHLLFYI/AAAAAAAAIVo/S2ul_7uXfFY/s200/letter-e.jpg',
        sound: mp3_e       
    },
    {
        id: 6,
        value: 'f',
        img: 'http://4.bp.blogspot.com/-QFkwoZJ8whU/Tkq-tBPUdqI/AAAAAAAAIVs/wyN8IRl7GxI/s200/letter-f.jpg',
        sound: mp3_f        
    },
    {
        id: 7,
        value: 'g',
        img: 'http://3.bp.blogspot.com/-BeD6bVpplfw/Tkq-uP9ZZuI/AAAAAAAAIVw/-AoWSpqe59M/s200/letter-g.jpg',
        sound: mp3_g        
    },
    {
        id: 8,
        value: 'h',
        img: 'http://1.bp.blogspot.com/-983HZwHCVAs/Tkq-1k4eMzI/AAAAAAAAIV0/VF9jOU9gZHA/s200/letter-h.jpg',
        sound: mp3_h        
    },
    {
        id: 9,
        value: 'i',
        img: 'http://2.bp.blogspot.com/-XJ-qJu9Qi5o/Tkq_FKAy23I/AAAAAAAAIV4/8h2XQeP5UIY/s200/letter-i.jpg',
        sound: mp3_i        
    },
    {
        id: 10,
        value: 'j',
        img: 'http://3.bp.blogspot.com/-CQ1_iMn3ymo/Tkq_F2iU-7I/AAAAAAAAIV8/ZlQFPKBJm-Y/s200/letter-j.jpg',
        sound: mp3_j        
    },
    {
        id: 11,
        value: 'k',
        img: 'http://4.bp.blogspot.com/-K2FCPhjMSkI/Tkq_JonoIfI/AAAAAAAAIWA/OMszgN6Cdws/s200/letter-k.jpg',
        sound: mp3_k        
    },
    {
        id: 12,
        value: 'l',
        img: 'http://4.bp.blogspot.com/-opYFri5v7Cs/Tkq_KTmLCnI/AAAAAAAAIWE/VtXOBxcSenw/s200/letter-l.jpg',
        sound: mp3_l       
    },
    {
        id: 13,
        value: 'm',
        img: 'http://4.bp.blogspot.com/-1ZKdAgZfpoU/Tkq_K_BwkeI/AAAAAAAAIWI/4cjNp6x_2QQ/s200/letter-m.jpg',
        sound: mp3_m        
    },
    {
        id: 14,
        value: 'n',
        img: 'http://3.bp.blogspot.com/-bazGZ8msKK8/TzZ6D5svRrI/AAAAAAAALWc/OzldmXt2_4c/s200/letter-n.jpg',
        sound: mp3_n       
    },
    {
        id: 15,
        value: 'o',
        img: 'http://3.bp.blogspot.com/-t3TcYDhnRDw/Tkq_P1HdcRI/AAAAAAAAIWM/UVihkQ7meb4/s200/letter-o.jpg',
        sound: mp3_o       
    },
    {
        id: 16,
        value: 'p',
        img: 'http://3.bp.blogspot.com/-9In7ThbhhaM/Tkq_QlKkPSI/AAAAAAAAIWQ/XvgZHXyzCCg/s200/letter-p.jpg',
        sound: mp3_p        
    },
    {
        id: 17,
        value: 'q',
        img: 'http://3.bp.blogspot.com/-XXZsJrGBgTw/Tkq_Ra-_UdI/AAAAAAAAIWU/C8Z9k-Hyck4/s200/letter-q.jpg',
        sound: mp3_q        
    },
    {
        id: 18,
        value: 'r',
        img: 'http://2.bp.blogspot.com/-ZEpVecXtB3k/Tkq_SYkpZAI/AAAAAAAAIWY/vMx_t_b43is/s200/letter-r.jpg',
        sound: mp3_r        
    },
    {
        id: 19,
        value: 's',
        img: 'http://3.bp.blogspot.com/-k__jDmEwjes/Tkq_TOKCd_I/AAAAAAAAIWc/0nRIieqqxb4/s200/letter-s.jpg',
        sound: mp3_s        
    },
    {
        id: 20,
        value: 't',
        img: 'http://4.bp.blogspot.com/-vmIr3AqgePE/Tkq_Tm4_1cI/AAAAAAAAIWg/cCmqzY3zuK4/s200/letter-t.jpg',
        sound: mp3_t        
    },
    {
        id: 21,
        value: 'u',
        img: 'http://3.bp.blogspot.com/-3z0VkrRi7ss/TzZ6Y7P4f3I/AAAAAAAALWk/WubHuq2ArCM/s200/letter-u.jpg',
        sound: mp3_u        
    },
    {
        id: 22,
        value: 'v',
        img: 'http://3.bp.blogspot.com/-ssW8cqFRBcU/Tkq_eNdYwfI/AAAAAAAAIWk/_70A_XHN36Y/s200/letter-v.jpg',
        sound: mp3_v       
    },
    {
        id: 23,
        value: 'w',
        img: 'http://4.bp.blogspot.com/-JhgLah_0yo4/Tkq_fbDSw9I/AAAAAAAAIWo/sgui2rceWwQ/s200/letter-w.jpg',
        sound: mp3_w        
    },
    {
        id: 24,
        value: 'x',
        img: 'http://1.bp.blogspot.com/-5TVwI9295f8/Tkq_gFhI7OI/AAAAAAAAIWs/_I62wMBJhV0/s200/letter-x.jpg',
        sound: mp3_x        
    },
    {
        id: 25,
        value: 'y',
        img: 'http://1.bp.blogspot.com/-0IxuYBh9MLY/Tkq_gwsmtiI/AAAAAAAAIWw/cL2ljTG09oE/s200/letter-y.jpg',
        sound: mp3_y        
    },
    {
        id: 26,
        value: 'z',
        img: 'http://4.bp.blogspot.com/-EY2ffpJTlm8/Tkq_iS_1EKI/AAAAAAAAIW0/YIpdOX7fIGo/s200/letter-z.jpg',
        sound: mp3_z       
    },
    
];


// export const letters = [
//     {
//         id: 1,
//         value: 'a',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/a.gif',
//         sound: ''        
//     },
//     {
//         id: 2,
//         value: 'b',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/b.gif',
//         sound: ''        
//     },
//     {
//         id: 3,
//         value: 'c',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/c.gif',
//         sound: ''        
//     },
//     {
//         id: 4,        
//         value: 'd',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/d.gif',
//         sound: ''        
//     },
//     {
//         id: 5,
//         value: 'e',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/e.gif',
//         sound: ''        
//     },
//     {
//         id: 6,
//         value: 'f',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/f.gif',
//         sound: ''        
//     },
//     {
//         id: 7,
//         value: 'g',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/g.gif',
//         sound: ''        
//     },
//     {
//         id: 8,
//         value: 'h',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/h.gif',
//         sound: ''        
//     },
//     {
//         id: 9,
//         value: 'i',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/I.gif',
//         sound: ''        
//     },
//     {
//         id: 10,
//         value: 'j',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/J.gif',
//         sound: ''        
//     },
//     {
//         id: 11,
//         value: 'k',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/k.gif',
//         sound: ''        
//     },
//     {
//         id: 12,
//         value: 'l',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/l.gif',
//         sound: ''        
//     },
//     {
//         id: 13,
//         value: 'm',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/m.gif',
//         sound: ''        
//     },
//     {
//         id: 14,
//         value: 'n',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/n.gif',
//         sound: ''        
//     },
//     {
//         id: 15,
//         value: 'o',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/o.gif',
//         sound: ''        
//     },
//     {
//         id: 16,
//         value: 'p',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/p.gif',
//         sound: ''        
//     },
//     {
//         id: 17,
//         value: 'q',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/q.gif',
//         sound: ''        
//     },
//     {
//         id: 18,
//         value: 'r',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/r.gif',
//         sound: ''        
//     },
//     {
//         id: 19,
//         value: 's',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/s.gif',
//         sound: ''        
//     },
//     {
//         id: 20,
//         value: 't',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/t.gif',
//         sound: ''        
//     },
//     {
//         id: 21,
//         value: 'u',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/u.gif',
//         sound: ''        
//     },
//     {
//         id: 22,
//         value: 'v',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/v.gif',
//         sound: ''        
//     },
//     {
//         id: 23,
//         value: 'w',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/w.gif',
//         sound: ''        
//     },
//     {
//         id: 24,
//         value: 'x',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/x.gif',
//         sound: ''        
//     },
//     {
//         id: 25,
//         value: 'y',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/y.gif',
//         sound: ''        
//     },
//     {
//         id: 26,
//         value: 'z',
//         img: 'http://morecoloring.com/wp-content/themes/morecoloring/images/abc_flash_1/Z.gif',
//         sound: ''        
//     },
    
// ];





// WEBPACK FOOTER //
// ./src/component/data.js